import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Menu } from 'grab-ui';
import { ExceptMobile, Mobile } from 'components/v2/responsive';
import { trackClick, event, cat, custom } from 'common/utils/instrumentation';
import { getCompanyID, getUserCountryCode } from 'helper/user';
import {
  userInfoSelector,
  activeHistoryQtySelector,
  enableShopifyOrdersSelector,
} from 'selectors/app-selector';
import { shopifyShopsSelector } from 'selectors/shopify-selectors';
import { fetchShopifyShopsAction } from 'actions/shopify-actions';
import { isAdminSelector } from 'selectors/login-selector';
import Routes from 'RoutesV2';
import { APP_BASE_URL_NAME } from 'constants/app-constants';
import {
  scribeTrackEvent,
  getCommonFacet,
  SCRIBE_COMMON_EVENTS,
  SCRIBE_COMMON_EVENTS_STATE_PATH_MAPPING,
} from 'applications/scribe/instrumentations/track';

import css from './app-sider.less';

const getOpenKeys = pathname => {
  const splits = pathname.split('/');
  return splits.length > 1 ? [splits[1]] : [pathname];
};

const { Item } = Menu;
const GFB_KEY = 'GFB_KEY';

export class AppSider extends Component {
  constructor(props) {
    super(props);
    const { location: { pathname } } = props;
    this.state = {
      selectedKeys: getOpenKeys(pathname),
    };
  }

  componentDidMount() {
    const {
      enableShopifyOrders,
      shopifyShops,
      dispatch,
      userInfo,
    } = this.props;
    if (enableShopifyOrders && shopifyShops === null) {
      dispatch(
        fetchShopifyShopsAction({
          countryCode: getUserCountryCode(userInfo),
        }),
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const { location: { pathname } } = nextProps;
    this.setState({
      selectedKeys: getOpenKeys(pathname),
    });
  }

  onClickRouteTo = ({ key }) => {
    const { userInfo, history, location: { pathname } } = this.props;
    const eventName =
      pathname === '/home' ? event.HOMEPAGE_CLICKS : event.BOOKINGS_CLICKS;
    const categoryName =
      pathname === '/home' ? cat.GE_HOMEPAGE : cat.GE_BOOKINGS;
    const companyID = getCompanyID(userInfo);

    if (key === GFB_KEY) {
      trackClick(eventName, categoryName, 'ADMIN', {
        [custom.COMPANY_ID]: companyID,
      });

      if (SCRIBE_COMMON_EVENTS_STATE_PATH_MAPPING.ADMIN[pathname]) {
        scribeTrackEvent({
          stateName: SCRIBE_COMMON_EVENTS_STATE_PATH_MAPPING.ADMIN[pathname],
          eventName: SCRIBE_COMMON_EVENTS.ADMIN,
          facets: getCommonFacet(userInfo),
        });
      }

      /* Hard redirect requires we add ${APP_BASE_URL_NAME} since we're outside of <BrowserRouter> */
      window.open(
        // eslint-disable-next-line prettier/prettier
        `${window.location.origin}/${APP_BASE_URL_NAME}/${
          Routes.redirectGfb.key
        }`,
      );
      return;
    }

    if (key === Routes.bookings.path) {
      trackClick(eventName, categoryName, 'BOOKINGS', {
        [custom.COMPANY_ID]: companyID,
      });

      if (SCRIBE_COMMON_EVENTS_STATE_PATH_MAPPING.BOOKINGS[pathname]) {
        scribeTrackEvent({
          stateName: SCRIBE_COMMON_EVENTS_STATE_PATH_MAPPING.BOOKINGS[pathname],
          eventName: SCRIBE_COMMON_EVENTS.BOOKINGS,
          facets: getCommonFacet(userInfo),
        });
      }
    }

    if (key === Routes.home.path) {
      trackClick(eventName, categoryName, 'HOME', {
        [custom.COMPANY_ID]: companyID,
      });

      if (SCRIBE_COMMON_EVENTS_STATE_PATH_MAPPING.HOME[pathname]) {
        scribeTrackEvent({
          stateName: SCRIBE_COMMON_EVENTS_STATE_PATH_MAPPING.HOME[pathname],
          eventName: SCRIBE_COMMON_EVENTS.HOME,
          facets: getCommonFacet(userInfo),
        });
      }
    }

    history.push(key);
  };

  onClickRouteToMobile = ({ key }) => {
    const { onToggleMobileDrawer } = this.props;

    onToggleMobileDrawer();
    this.onClickRouteTo({ key });
  };

  renderMenu = ({ mode, onClick }) => {
    const { selectedKeys } = this.state;
    const { isUserAdmin, enableShopifyOrders } = this.props;

    return (
      <Menu
        theme="light"
        mode={mode}
        defaultSelectedKeys={selectedKeys}
        selectedKeys={selectedKeys}
        onClick={onClick}
        className={css.sider}
      >
        <Item key={Routes.home.path}>{I18n.t('v2.sider.home')}</Item>
        <Item key={Routes.bookings.path}>{I18n.t('v2.sider.bookings')}</Item>
        {enableShopifyOrders && (
          <Item key={Routes.shopifyHome.path}>
            {I18n.t('v2.sider.shopifyHome')}
          </Item>
        )}
        {isUserAdmin && (
          <Item key={GFB_KEY}>
            <Row type="flex">
              <span>{I18n.t('v2.sider.admin')}</span>
              <img
                className={css.adminIcon}
                src={require('public/icons/redirect.svg')}
                alt=""
              />
            </Row>
          </Item>
        )}
      </Menu>
    );
  };

  render() {
    const { showMobileView } = this.props;

    return (
      <Fragment>
        <ExceptMobile>
          <div className={css.siderWrapper}>
            {this.renderMenu({
              mode: 'horizontal',
              onClick: this.onClickRouteTo,
            })}
          </div>
        </ExceptMobile>
        {showMobileView && (
          <Mobile>
            <div className={css.siderWrapperMobile}>
              {this.renderMenu({
                mode: 'vertical',
                onClick: this.onClickRouteToMobile,
              })}
            </div>
          </Mobile>
        )}
      </Fragment>
    );
  }
}

AppSider.propTypes = {
  showMobileView: PropTypes.bool,
  isUserAdmin: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  onToggleMobileDrawer: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  shopifyShops: PropTypes.arrayOf(PropTypes.shape({})),
  enableShopifyOrders: PropTypes.bool.isRequired,
};

AppSider.defaultProps = {
  shopifyShops: null,
  showMobileView: false,
  onToggleMobileDrawer: () => {},
};

export const mapStateToProps = state => ({
  userInfo: userInfoSelector(state),
  activeHistoryQty: activeHistoryQtySelector(state),
  isUserAdmin: isAdminSelector(state),
  shopifyShops: shopifyShopsSelector(state),
  enableShopifyOrders: enableShopifyOrdersSelector(state),
});

export default withRouter(connect(mapStateToProps)(AppSider));
